import { Card, Grid, Typography, Box, Tabs, Tab, AppBar } from '@mui/material';
import React from 'react';
import { useStyles } from './style';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import MeetIcon from '../../Assets/meetIcon.png';
import { AppButton } from '../../Components/AppButton';
import KenColors from '../../Helpers/Themes/kenColors';
import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import dayjs from 'dayjs';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div role="tabpanel" hidden={value !== index} id={`simple-tabpanel-${index}`} aria-labelledby={`simple-tab-${index}`} {...other}>
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

const sceduleData = [
  {
    sceduleName: 'Applied Physics',
    startTime: '09:00',
    sceduleType: 'Chapter Thermodynamic',
    time: '09:00 AM - 10:30 AM',
  },
  {
    sceduleName: 'Java',
    startTime: '11:00',
    sceduleType: 'Fundamentals of java',
    time: '09:00 AM - 10:30 AM',
  },
  {
    sceduleName: 'Java',
    startTime: '11:00',
    sceduleType: 'Fundamentals of java',
    time: '09:00 AM - 10:30 AM',
  },
  {
    sceduleName: 'Lunch',
    startTime: '13:00',
  },
  {
    sceduleName: 'Applied Physics',
    startTime: '09:00',
    sceduleType: 'Chapter Thermodynamic',
    time: '09:00 AM - 10:30 AM',
  },
  {
    sceduleName: 'Applied Physics',
    startTime: '09:00',
    sceduleType: 'Chapter Thermodynamic',
    time: '09:00 AM - 10:30 AM',
  },
];
const Schedule = () => {
  const classes = useStyles();
  const [value, setValue] = React.useState(0);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };
  return (
    <div>
      <Card className={classes.ScheduleCard}>
        <Grid container spacing={2}>
          <Grid item xs={5}>
            <Typography className={classes.ScheduleTitle}>My Calendar</Typography>
          </Grid>
          <Grid item xs={3}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DemoContainer components={['DatePicker']} sx={{ width: '100%' }}>
                <DatePicker
                  label="Basic date picker"
                  value={dayjs()}
                  sx={{
                    width: '100%',
                    '& .MuiInputBase-root': {
                      height: '36px',
                    },
                  }}
                  slotProps={{
                    textField: {
                      size: 'small',
                      sx: {
                        '& .MuiInputLabel-root': {
                          fontSize: '12px',
                        },
                      },
                    },
                  }}
                />
              </DemoContainer>
            </LocalizationProvider>
          </Grid>{' '}
          <Grid item xs={4}>
            <Box sx={{ width: '100%' }}>
              {/* <Tabs
                  value={value}
                  onChange={handleChange}
                  aria-label="basic tabs example"
                  sx={{
                    width: '100%',
                  }}
                  allowScrollButtonsMobile
                  variant="fullWidth"
                >
                  <Tab
                    label="Day"
                    {...a11yProps(0)}
                    sx={{
                      textTransform: 'none',
                      fontSize: '15px',
                      minHeight: '36px',
                      height: '36px',
                    }}
                  />
                  <Tab label="Week" {...a11yProps(1)} sx={{ textTransform: 'none', fontSize: '15px', minHeight: '36px', height: '36px' }} />
                  <Tab label="Month" {...a11yProps(2)} sx={{ textTransform: 'none', fontSize: '15px', minHeight: '36px', height: '36px' }} />
                </Tabs> */}
              <AppBar position="static" sx={{ height: '39px', boxShadow: 'none', mt: 1, borderRadius: '6px' }}>
                <Tabs
                  value={value}
                  onChange={handleChange}
                  indicatorColor="secondary"
                  textColor="inherit"
                  variant="fullWidth"
                  aria-label="full width tabs example"
                  sx={{
                    minHeight: '36px',
                    border: '0.38px solid #B2B3B7',
                    borderRadius: '6px',
                    '& .MuiTab-root': {
                      minHeight: '36px',
                      fontSize: '12px',
                    },
                    backgroundColor: 'white',
                    color: 'black',
                    boxShadow: 'none',
                  }}
                  TabIndicatorProps={{
                    sx: {
                      backgroundColor: '#2C58E8',
                    },
                  }}
                >
                  <Tab
                    label="Day"
                    {...a11yProps(0)}
                    sx={{
                      textTransform: 'none',
                      fontSize: '12px',
                    }}
                  />
                  <Tab
                    label="Week"
                    {...a11yProps(1)}
                    sx={{
                      textTransform: 'none',
                      fontSize: '12px',
                    }}
                  />
                  <Tab
                    label="Month"
                    {...a11yProps(2)}
                    sx={{
                      textTransform: 'none',
                      fontSize: '12px',
                    }}
                  />
                </Tabs>
              </AppBar>
            </Box>
          </Grid>
        </Grid>
      </Card>
      <Card className={classes.ScheduleCard1} sx={{ mt: 2 }}>
        <CustomTabPanel value={value} index={0}>
          <Box sx={{ height: '56vh' }} className="scrollbar-cusgray">
            {sceduleData.map((val, index) => {
              return (
                <Grid container spacing={2} sx={{ mt: 2 }}>
                  <Grid item xs={4} sm={4} md={1} lg={1} xl={1}>
                    <Typography sx={{ textAlign: 'left', fontSize: '12px', fontWEight: 500 }}>{val.startTime}</Typography>
                  </Grid>
                  <Grid
                    item
                    xs={8}
                    sm={8}
                    md={10.8}
                    lg={10.8}
                    xl={10.8}
                    sx={{
                      backgroundColor: index == 3 ? '#FEEBBE' : '#EAEFFF',
                      borderLeft: index == 3 ? '2px solid #E4AF29' : '2px solid #2C58E8',
                      borderRadius: 3,
                      p: 1,
                    }}
                  >
                    <Typography sx={{ textAlign: 'left', fontWeight: 600, fontSize: '10.5px' }}>{val.sceduleName}</Typography>
                    <Typography sx={{ textAlign: 'left', fontWeight: 400, fontSize: '10.5px' }}>{val.sceduleType}</Typography>
                    {val.time && (
                      <Box sx={{ display: 'flex', justifyContent: 'start', mb: 1 }}>
                        <AccessTimeIcon sx={{ mt: 1.5, fontSize: '15px' }} />
                        <Typography sx={{ textAlign: 'left', fontSize: '10.5px', fontWeight: 500, mt: 1.5, ml: 1 }}>{val.time}</Typography>
                      </Box>
                    )}
                  </Grid>
                </Grid>
              );
            })}
          </Box>
          <hr style={{ border: '1px solid #E5E6EA' }} />
          <Box sx={{ display: 'flex', justifyContent: 'end', width: '100%' }}>
            <AppButton size="small" variant="contained" className={classes.postJobBtns} others={{ color: KenColors.kenWhite, height: '36px', borderRadius: '6px' }}>
              <Typography sx={{ fontSize: '12px', fontWeight: 500 }}>Schedule one-on-one call</Typography>
            </AppButton>
          </Box>
        </CustomTabPanel>
        <CustomTabPanel value={value} index={1}>
          <div style={{ width: '100%', height: '56vh', padding: '20px' }} className="scrollbar-cusgray">
            <FullCalendar
              plugins={[dayGridPlugin]}
              initialView="dayGridMonth"
              events={[
                { title: 'Event 1', date: '2024-09-20' },
                { title: 'Event 2', date: '2024-09-22' },
              ]}
              contentHeight="auto"
              eventContent={(eventInfo) => <div style={{ fontSize: '12px' }}>{eventInfo.event.title}</div>}
            />
          </div>
          <hr style={{ border: '1px solid #E5E6EA' }} />
          <Box sx={{ display: 'flex', justifyContent: 'end', width: '100%' }}>
            <AppButton size="small" variant="contained" className={classes.postJobBtns} others={{ color: KenColors.kenWhite, height: '36px', borderRadius: '6px' }}>
              <Typography sx={{ fontSize: '12px', fontWeight: 500 }}>Schedule one-on-one call</Typography>
            </AppButton>
          </Box>
        </CustomTabPanel>
        <CustomTabPanel value={value} index={2}>
          <div style={{ width: '100%', height: '56vh', padding: '20px' }} className="scrollbar-cusgray">
            <FullCalendar
              plugins={[dayGridPlugin]}
              initialView="dayGridMonth"
              events={[
                { title: 'Event 1', date: '2024-09-20' },
                { title: 'Event 2', date: '2024-09-22' },
              ]}
            />
          </div>
          <hr style={{ border: '1px solid #E5E6EA' }} />
          <Box sx={{ display: 'flex', justifyContent: 'end', width: '100%' }}>
            <AppButton size="small" variant="contained" className={classes.postJobBtns} others={{ color: KenColors.kenWhite, height: '36px', borderRadius: '6px' }}>
              <Typography sx={{ fontSize: '12px', fontWeight: 500 }}>Schedule one-on-one call</Typography>
            </AppButton>
          </Box>
        </CustomTabPanel>
      </Card>
    </div>
  );
};

export default Schedule;
